<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="账户类型：">
        <el-select v-model="query.exportType" placeholder="请选择" clearable size="small" @change="handleChange" @clear="query.clevel=''">
          <el-option :label="item.accountTypeName" :value="item.accountType" v-for="item in typeOption" :key="item.accountType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入账来源：">
        <el-select v-model="query.commissionSource" filterable placeholder="请选择" clearable size="small">
          <el-option :label="item.configName" :value="item.configKey" v-for="(item,index) in sourceOptions" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份：">
        <el-select v-model="query.clevel" placeholder="请选择" clearable size="small" :disabled="!query.exportType">
          <el-option :label="item.name" :value="item.level" v-for="item in sectionList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import sysGoodsApi from '@/api/goods/sysGoods'
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import { filterEmpty } from '@/utils'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        clevel: null,
        exportType: null,
        commissionSource: null
      },
      categorizeIdArr: [],
      categorizeOptions: [],  //商品分类
      sectionList: [],
      options: [],
      typeOption: [],
      dateTime: [],
      commisstionSource: [{ configKey: 1, configName: '订货' }, { configKey: 2, configName: '秒杀' }, { configKey: 3, configName: '充值' }, { configKey: 4, configName: '学费' },
      { configKey: 5, configName: '提现' }, { configKey: 6, configName: '管理后台扣减' }, { configKey: 7, configName: '课程' }, { configKey: 8, configName: '会议' }, { configKey: 9, configName: '线下凭证升级' }],
      reasonOptions: [],
      sourceOptions:[]
    }
  },
  created() {
    // this.sectionList=JSON.parse(localStorage.getItem('levelList'))
    this.getOption()
    this.getReasonOption()
  },
  methods: {
    getReasonOption() {
      sysGiftAccountReasonApi.findOption().then(({ data }) => {
        if (data) {
          this.reasonOptions = data
        }
      })
    },
    async getOption() {
      const { data } = await managecustomerwalletApi.findCustomerWalletTypeShow()
      this.options = data
      this.typeOption = data.map(item => ({ accountType: item.accountType, accountTypeName: item.accountTypeName }))
      // console.log('data: ',data);
    },
    handleChange(e) {
      this.sectionList = this.options.find(i => i.accountType == e).levelList
      this.query.clevel = '';
      //处理入账来源
      this.query.commissionSource = ''
      this.sourceOptions = this.query.exportType == 1 ? this.commisstionSource : this.reasonOptions
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      let params = JSON.parse(JSON.stringify(this.query))
      if(params.exportType != 1 && params.commissionSource){
        params.useCode = params.commissionSource
        delete params.commissionSource
      }
      return this.$common.confirm('是否确认导出')
        .then(() => managecustomerwalletApi.exportExcel(filterEmpty(params))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },

  }

}
</script>

<style>
</style>
